import { Box, Link, styled, Theme, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';

export const HeaderWrapper = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    height: '72px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: palette.white,
  };
});

export const HeaderContent = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '80%',
    minHeight: '72px',
    maxHeight: '80px',
    display: 'flex',
    justifyContent: 'space-between',

    [theme.breakpoints.down('desktop')]: {
      width: '95%',
    },

    [theme.breakpoints.down('tablet')]: {
      width: '100%',
      padding: '0 16px',
    },
  };
});

export const HeaderLeftBlock = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: 'max-content',
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
  };
});

export const HeaderRightBlock = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: 'max-content',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  };
});

export const HeaderAvatar = styled(Box)(({ theme }: { theme: Theme }) => {
  return {
    width: '40px',
    height: '40px',
    position: 'relative',
    borderRadius: '50%',
    backgroundColor: palette.primary.purple900,
    cursor: 'pointer',

    /* '&::before': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      right: 0,
      width: '10px',
      height: '10px',
      border: `2px solid ${palette.white}`,
      borderRadius: '50%',
      backgroundColor: palette.color_system.success_green,
      zIndex: 1000,
    }, */
  };
});

export const HeaderAvatarImg = styled('img')({
  display: 'block',
  width: '40px',
  height: '40px',
  position: 'relative',
  borderRadius: '50%',
  cursor: 'pointer',
});

export const HeaderLink = styled(Link)<{ selected: any }>(({ selected }) => {
  return {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    color: palette.text.header,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '19px',
    cursor: 'pointer',
    textDecoration: 'none',
    position: 'relative',
    pointerEvents: selected ? 'none' : 'initial',

    '&::before': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%',
      height: '4px',
      backgroundColor: selected ? '#5D2F89' : 'transparent',
    },
  };
});

export const HeaderPopoverContent = styled(Box)({
  width: '268px',
  height: 'auto',
  padding: '16px',
});

export const HeaderPopoverContentHeading = styled(Box)({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  borderBottom: '1px solid #D8DBE8',
  paddingBottom: '16px',

  '> div': {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
});

export const HeaderPopoverContentHeadingTexts = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
});

export const HeaderPopoverContentHeadingTextsTitle = styled(Typography)({
  color: '#2B163F',
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '128%',
});

export const HeaderPopoverContentHeadingTextsDesc = styled(Typography)({
  color: '#666666',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '136%',
});

const ItemLink = styled(Link)(({ theme }: { theme: Theme }) => {
  return {
    width: '100%',
    display: 'block',
    color: palette.text.body,
    fontWeight: 400,
    cursor: 'pointer',
    padding: '10px 24px',
    fontSize: '16px',
    lineHeight: '22px',
    textDecoration: 'none',
    borderRadius: '12px',

    '&:hover': {
      backgroundColor: palette.hover.background,
    },
  };
});

export const MenuItemLink = styled(ItemLink)<{ selected?: boolean }>(({ selected }) => {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: selected ? palette.text.header : palette.text.body,
    fontWeight: selected ? 500 : 400,
    cursor: selected ? 'auto' : 'pointer',
    pointerEvents: selected ? 'none' : 'auto',
    borderLeft: '4px solid',
    borderColor: selected ? palette.primary.purple500 : 'transparent',
    backgroundColor: selected ? palette.hover.background : 'transparent',
  };
});

export const HeaderNotifications = styled(Box)({
  position: 'relative',
  cursor: 'pointer',

  '> span': {
    minWidth: '10px',
    minHeight: '10px',
    backgroundColor: '#85C553',
    borderRadius: '50%',
    border: '1px solid #fff',
    position: 'absolute',
    top: '23px',
    right: '15px',
    lineHeight: '1',
  },
});

export const HeaderMessages = styled(Box)({
  position: 'relative',
  cursor: 'pointer',

  '> span': {
    minWidth: '10px',
    minHeight: '10px',
    backgroundColor: '#85C553',
    borderRadius: '50%',
    border: '2px solid #fff',
    position: 'absolute',
    top: '23px',
    right: '10px',
    lineHeight: '1',
  },
});

export const NotificationsContainer = styled(Box)({
  width: '369px',
  height: '500px',
});

export const NotificationsHeader = styled(Box)({
  height: '60px',
  padding: '18px 16px',
  borderBottom: '1px solid #D8DBE8',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  '> div': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },

  '> p': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '5px',
    fontWeight: 600,
    fontSize: '16px',
    color: '#2B163F',
    lineHeight: '128%',

    '> span': {
      color: '#A9A9A9',
    },
  },
});

export const NotificationsNoContentMain = styled(Box)({
  width: '100%',
  height: 'calc(100% - 60px)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const NotificationsMain = styled(Box)({
  width: '100%',
  height: 'calc(100% - 60px)',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',
});

export const NotificationsMainItem = styled(Box)({
  position: 'relative',
  width: '100%',
  display: 'flex',
  padding: '16px',
  gap: '12px',
  borderBottom: '1px solid #D8DBE8',
});

export const NotificationsMainItemTitle = styled(Typography)({
  fontWeight: 600,
  fontSize: '14px',
  color: '#2B163F',
  lineHeight: '128%',
});

export const NotificationsMainItemDesc = styled(Typography)({
  fontWeight: 400,
  fontSize: '14px',
  color: '#444444',
  lineHeight: '136%',
  marginBottom: '8px',
});

export const NotificationsMainItemLink = styled(Typography)({
  fontWeight: 600,
  fontSize: '14px',
  color: '#663497',
  lineHeight: '136%',
  cursor: 'pointer',
});

export const NotificationsMainItemIsRead = styled('span')({
  width: '10px',
  height: '10px',
  backgroundColor: '#85C553',
  borderRadius: '50%',
  position: 'absolute',
  top: '20px',
  right: '16px',
});
